export const statusNegDiffApproval = {
  backOffice: 'B',
  directors: 'D',
  pending: 'P',
  reject: 'R'
} as const

type StatusNegDiffApprovalKeys = keyof typeof statusNegDiffApproval
export type StatusNegDiffApprovalValues =
  typeof statusNegDiffApproval[StatusNegDiffApprovalKeys]
